<template>
	<div>
		<h1 class="view-title" data-v-step-driver="1">
			MOTORISTAS <span v-popover:tooltip.right="'Seção de listagem dos Motoristas'"><i class="fas fa-question-circle"></i></span>
		</h1>
		<div class="inner-content shadowed">
			<div class="inner-content-title">
				Lista <span v-popover:tooltip.right="'Lista dos motoristas cadastrados'"><i class="fas fa-question-circle"></i></span>
				<button class="add-new" @click="show_driver_search = true" :data-v-step-driver="client_atak ? '5' : '4'" :disabled="!$permission.hasAreaEditPermission('Driver')">
					<i class="fas fa-fw fa-mobile"></i> VINCULAR
				</button>
				<button v-if="client_atak" class="btn-delivery" @click="show_driver_synchronization_atak = true" :data-v-step-driver="client_atak ? '4' : ''">
					<i class="fas" :class="loading ? 'fa-circle-notch fa-spin': 'fa-sync'"></i> SINCRONIZAR
				</button>
				<button class="btn-delivery" @click="show_driver_form = true" data-v-step-driver="3" :disabled="!$permission.hasAreaEditPermission('Driver')">
					<i class="fas" :class="loading ? 'fa-circle-notch fa-spin': 'fa-plus'"></i> ADICIONAR
				</button>
				<button class="btn btn-link btn-right" @click="$refs.tour.editTour()" style="margin-top: 10px; margin-left: 15px;" data-v-step-driver="2">
                    <i class="fas fa-question-circle"></i> TOUR
                </button>
			</div>
			<div class="row">
				<div class="col-xs-12 col-lg-12">
					<div class="search" :data-v-step-driver="client_atak ? '6' : '5'">
                        <label>Filtro <span v-popover:tooltip.right="'Informe uma palavra-chave para identificação do registro desejado'"><i class="fas fa-question-circle"></i></span>:</label>
                        <input type="text" v-model="search" @keydown.enter.prevent="load(true)" /> 
                    </div>
					<Table 
					:loading="loading"
					:headers="headers" 
					:ordering="ordering" 
					:order="order" 
					@reorder="(o) => { order = o; load(); }"
					:list="list" 
					:page="page"
					:per_page="per_page" 
					:total="total" 
					:modifiers="modifiers"
					@next="() => { page++; load(); }" 
					@prev="() => { page--; load(); }"
					v-slot="{item}"
					:data-v-step-driver="client_atak ? '7' : '6'">
						<button  @click="openDriverForm(item)" class="button-edit" title="Editar motorista" :disabled="!$permission.hasAreaEditPermission('Driver')">
							<i class="fa fa-fw fa-edit"></i>
						</button>
						<button  @click="openDriverRoute(item)" class="button-edit" title="Ver rota">
							<i class="fa fa-fw fa-map-marked-alt"></i>
						</button>
						<button @click="changePassword(item.id)" class="button-edit" title="Alterar senha" :disabled="!$permission.hasAreaEditPermission('Driver')">
							<i class="fa fa-fw fa-lock"></i>
						</button>
						<button @click="removeMyDriver(item.id)" class="button-remove" title="Desvincular motorista" :disabled="!$permission.hasAreaEditPermission('Driver')">
							<i class="fa fa-fw fa-trash"></i>
						</button>
					</Table>
				</div>

			</div>
		</div>

		<DriverEdit v-if="show_driver_edit"
			:current="current"
			@close="closeDriverEdit"
		/>

		<DriverForm v-if="show_driver_form"
			:current="current"
			:my_vehicles="my_vehicles"
			@close="closeDriverForm"
		/>

		<DriverRoute v-if="show_driver_route"
			:current="current"
			:settings="settings"
			@close="closeDriverRoute"
		/>

		<DriverSearch v-if="show_driver_search"
			@close="closeDriverSearch"
		/>

		<DriverSynchronizationAtak v-if="show_driver_synchronization_atak" 
			:integration="settings.integration"
			:url_api_atak="settings.url_api_atak"
			@close="closeDriverSynchronizationAtak"
		/>

		<Tour
            tour="Driver"
            :steps="tour_steps"
			:callbackOnFinish="true"
			ref="tour"
        />
	</div>
</template>

<script>
import Api from "@/lib/Api";

import DriverEdit from "./Driver/DriverEdit";
import DriverForm from "./Driver/DriverForm";
import DriverRoute from "./Driver/DriverRoute";
import DriverSearch from "./Driver/DriverSearch";
import DriverSynchronizationAtak from "./Driver/DriverSynchronizationAtak";
import Table from "@/components/Table";
import Tour from "@/components/Tour";

export default {
	name: "Driver",

	components: {
		DriverEdit,
		DriverForm,
		DriverRoute,
		DriverSearch,
		DriverSynchronizationAtak,
		Table,
		Tour,
	},

	data: function() {
		let steps = [
			{
				target: '[data-v-step-driver="0"]',
				header: {
					title: '<code>SEÇÃO MOTORISTA</code>',
				},
				content: '<code>Clique no menu <b>MOTORISTA</b> para ir a seção de listagem e gerenciamento dos motoristas vinculados a empresa</code>',
				params: {
					placement: 'right',
					highlight: false,
				}
			},
			{
				target: '[data-v-step-driver="1"]',
				header: {
					title: '<code>SEÇÃO ATUAL</code>',
				},
				content: '<code>Identifique pelo título a seção que está atualmente</code>',
				params: {
					placement: 'bottom',
					highlight: true,
				}
			},
			{
				target: '[data-v-step-driver="2"]',
				header: {
					title: '<code>TOUR</code>',
				},
				content: '<code>Em caso de dúvida clique no botão <b>TOUR</b> para gerenciar a exibição do tour nessa seção, e assim ter um auxílio referente aos elementos da página</code>',
				params: {
					placement: 'left',
					highlight: true,
				}
			},
			{
				target: '[data-v-step-driver="3"]',
				header: {
					title: '<code>ADICIONAR MOTORISTA</code>',
				},
				content: '<code>Clique no botão <b>ADICIONAR</b> para abrir o formulário de cadastro de um novo motorista</code>',
				params: {
					placement: 'left',
					highlight: true,
				}
			},
		];
		
		if (this.$api.user.company_client_atak) {
			steps = steps.concat([
				{
                    target: '[data-v-step-driver="4"]',
                    header: {
                        title: '<code>SINCRONIZAR MOTORISTAS</code>',
                    },
                    content: '<code>Clique no botão <b>SINCRONIZAR</b> para abrir o modal de sincronização dos cadastros de motorista do seu sitema Atak</code>',
                    params: {
                        placement: 'left',
                        highlight: true,
                    }
                },
                {
                    target: '[data-v-step-driver="5"]',
                    header: {
                        title: '<code>VINCULAR MOTORISTA</code>',
                    },
                    content: '<code>Clique no botão <b>VINCULAR</b> para abrir o formulário de cadastro do vínculo com um novo motorista</code>',
                    params: {
                        placement: 'left',
                        highlight: true,
                    }
                },
                {
                    target: '[data-v-step-driver="6"]',
                    header: {
                        title: '<code>FILTRAGEM</code>',
                    },
                    content: '<code>Campo de filtragem da lista</code>',
                    params: {
                        placement: 'top',
                        highlight: true,
                    }
                },
                {
                    target: '[data-v-step-driver="7"]',
                    header: {
                        title: '<code>REGISTROS</code>',
                    },
                    content: '<code>Lista dos registros cadastrados</code>',
                    params: {
                        placement: 'top',
                        highlight: true,
                    }
                },
            ]);
		} else {
			steps = steps.concat([
                {
                    target: '[data-v-step-driver="4"]',
                    header: {
                        title: '<code>VINCULAR MOTORISTA</code>',
                    },
                    content: '<code>Clique no botão <b>VINCULAR</b> para abrir o formulário de cadastro do vínculo com um novo motorista</code>',
                    params: {
                        placement: 'left',
                        highlight: true,
                    }
                },
                {
                    target: '[data-v-step-driver="5"]',
                    header: {
                        title: '<code>FILTRAGEM</code>',
                    },
                    content: '<code>Campo de filtragem da lista</code>',
                    params: {
                        placement: 'top',
                        highlight: true,
                    }
                },
                {
                    target: '[data-v-step-driver="6"]',
                    header: {
                        title: '<code>REGISTROS</code>',
                    },
                    content: '<code>Lista dos registros cadastrados</code>',
                    params: {
                        placement: 'top',
                        highlight: true,
                    }
                },
            ]);
		}

		return {
			loading: false,
			headers: {
				name: "Nome",
				document: "CPF",
				nickname: "Identificador",
				email: "E-mail",
				phone: "Telefone",
			},
			ordering: ["name", "nickname"],
			order: 'name-ASC',
			list: [],
			page: 0,
			per_page: 20,
			total: 0,
			modifiers: {
				document: function(d) {
					return d.replace(/^(\d{3})(\d{3})(\d{3})(\d{2})/, "$1.$2.$3-$4");
				},
				email: function(d) {
					let str = "";
					let color = "";
					if (d) { 
						str = d.toLowerCase();
					} else {
						str = "Não Definido";
						color = "color: #aaa";
					}
					return `<span title="${str}" style="${color}">${str}</span>`;
				},
				phone: function(d) {
					let str = "";
					let color = "";
					if (d) { 
						if (d.length == 12) {
							str = d.replace(/^(\d{2})(\d{2})(\d{4})(\d{4})/, "+$1 ($2) $3-$4");
						} else {
							str = d.replace(/^(\d{2})(\d{2})(\d{5})(\d{4})/, "+$1 ($2) $3-$4");
						}
					} else {
						str = "Não Definido";
						color = "color: #aaa";
					}
					return `<span title="${str}" style="${color}">${str}</span>`;
				},
			},

			search: "",
			settings: null,
			my_vehicles: {},
			current: null,
			
			show_driver_edit: false,
			show_driver_form: false,
			show_driver_route: false,
			show_driver_search: false,
			show_driver_synchronization_atak: false,

			// Opção atak
			client_atak: this.$api.user.company_client_atak,
			
            tour_steps: steps,
		}
	},

	beforeCreate: function() {
		if (!this.$permission.hasAreaPermission("Driver")) {
            this.$router.push({ name: 'Home' });
        }
	},

	mounted: function() {
		this.$refs.tour.setTour();
		this.loadSettings();
		this.loadVehicles();
		this.load();

		if (this.$route.params.current_driver_route) {
			this.current_driver_route = this.$route.params.current_driver_route;
		}

		if (this.$route.params.show_map_current_driver_route) {
			this.show_map_current_driver_route = this.$route.params.show_map_current_driver_route;
		}
	},

	methods: {
		/** 
		 * Obtém as configurações padrão
		 **/
        loadSettings: async function() {
            let result = null;
            try {
                result = await Api.post("config/list-my-settings");
            } catch(ex) {
                console.log(ex);
                this.$notification.error("Não foi possível obter todas as informações de configuração.");
                return;
            }

			if (result) {
				if (result.error) {
					if (result.data == "unauthorized") {
						this.$notification.error("Desculpe, sua sessão expirou.");
						setTimeout(() => { 
							Api.logout();
							return;
						}, 2000);
					} else {
						this.$notification.error(result.data);
						return;
					}
				} else {
					this.settings = Object.assign({}, result.data);
					return;
				}
            } else {
				this.$notification.error("Não foi possível obter todas as informações de configuração.");
                return;
			}
        },

		/**
		 * Carrega lista de motorista
		 * @param {String} is_search busca de registros
		 */
		load: async function(is_search) {
			let form = {};

			if (this.search) form.search = this.search;

			if (is_search) this.page = 0;
			
			form.page = this.page;
			form.per_page = this.per_page;

			if (this.order) {
				form.order = this.order;
			}

			let result = null;
			this.list = [];
			this.total = 0;

			this.loading = true;
			try {
				result = await Api.post("driver/list", form);
			} catch (ex) {
				console.log(ex);
				this.loading = false;
				this.$notification.error("Não foi possível obter a lista de motoristas.");
				return;
			}
			this.loading = false;

			if (result) {
				if (result.error) {
					if (result.data == "unauthorized") {
						this.$notification.error("Desculpe, sua sessão expirou.");
						setTimeout(() => { 
							Api.logout();
							return;
						}, 2000);
					} else {
						this.$notification.error(result.data);
						return;
					}
				} else {
					this.list = result.data;
					this.total = result.total;
					return;
				}
			} else {
				this.$notification.error("Não foi possível obter a lista.");
				return;
			}
		},

		/**
         * Carrega a lista de filiais
         */
         loadVehicles: async function() {
            let result = null;

            try {
                result = await Api.post("vehicle/list-my-vehicles");
            } catch(ex) {
                console.log(ex);
                this.$notification.error("Não foi possível obter a lista de veículos.");
                return;
            }

			if (result) {
                if (result.error) {
                    if (result.data == "unauthorized") {
                        this.$notification.error("Desculpe, sua sessão expirou.");
                        setTimeout(() => { 
                            Api.logout();
                            return;
                        }, 2000);
                    } else {
                        this.$notification.error(result.data);
                        return;
                    }
                } else {
                    this.my_vehicles = result.data;
                    return;
                }
            } else {
                this.$notification.error("Não foi possível obter a lista de veículos.");
                return;
            }
		},

		removeMyDriver: async function(id) {
			let confirm = await this.$alert.confirm("Este motorista não poderá mais buscar cargas relacionadas à sua empresa.", "DESVINCULAR MOTORISTA?");
			if (!confirm) return;

			let form = {};
			form.id = id;
			
			let result = null;
			this.loading = true;
			try {
				result = await Api.post("driver/remove-driver", form);
			} catch (ex) {
				console.log(ex);
				this.loading = false;
				this.$notification.error("Não foi possível desvincular o motorista.");
				return;
			}
			this.loading = false;

			if (result) {
				if (result.error) {
					if (result.data == "unauthorized") {
						this.$notification.error("Desculpe, sua sessão expirou.");
						setTimeout(() => { 
							Api.logout();
							return;
						}, 2000);
					} else {
						this.$notification.error(result.data);
						return;
					}
				} else {
					this.$notification.success("Motorista desvinculado com sucesso.");
					
					this.load();
					return;
				}
			} else {
				this.$notification.error("Não foi possível desvincular.");
				return;
			}
		},

		changePassword: async function(id) {
			const new_password = await this.$alert.prompt("Insira a nova senha", "Alterar senha do motorista", { type: "text" });
			if (new_password === false) return;

			let result = null;
			this.loading = true;
			try {
				result = await Api.post("driver/change-password", {
					id: id,
					password: new_password
				});
			} catch (ex) {
				console.log(ex);
				this.loading = false;
				this.$notification.error("Não foi possível altrar a senha.");
				return;
			}
			this.loading = false;

			if (result) {
				if (result.error) {
					if (result.data == "unauthorized") {
						this.$notification.error("Desculpe, sua sessão expirou.");
						setTimeout(() => { 
							Api.logout();
							return;
						}, 2000);
					} else {
						this.$notification.error(result.data);
						return;
					}
				} else {
					this.$notification.success("Senha alterada com sucesso");
					return;
				}
			} else {
				this.$notification.error("Não foi possível fazer a alteração.");
				return;
			}
		},

		/**
		 * Abre o modal de edição do motorista atual
		 * @param {object} item objeto com informações do registro atual
		 */
		openDriverEdit: function(item) {
			this.current = item;
			this.show_driver_edit = true;
		},
		
		/**
		 * Fecha o modal de edição do motorista atual
		 */
		closeDriverEdit: function() {
			this.current = null;
			this.show_driver_edit = false;
			this.load();
		},
		
		/**
		 * Abre o modal de cadastro e edição de motorista
		 * @param {object} item objeto com informações do registro atual
		 */
		openDriverForm: function(item) {
			this.current = item;
			this.show_driver_form = true;
		},

		/**
		 * Fecha o modal de edição do motorista atual
		 */
		closeDriverForm: function() {
			this.current = null;
			this.show_driver_form = false;
			this.load();
		},
		
		/**
		 * Abre o modal de rota do motorista atual
		 * @param {object} item objeto com informações do registro atual
		 */
		openDriverRoute: function(item) {
			if (item.location) {
				this.current = item;
				this.show_driver_route = true;
			} else {
				this.$notification.error("Não foi registrado a posição deste motorista.");
			}
		},
		
		/**
		 * Fecha o modal de rota do motorista atual
		 */
		closeDriverRoute: function() {
			this.current = null;
			this.show_driver_route = false;
		},
		
		/**
		 * Fecha o modal de rota do motorista atual
		 */
		closeDriverSearch: function() {
			this.current = null;
			this.show_driver_search = false;
			this.load();
		},
		
		/**
		 * Abre o modal de rota do motorista atual
		 * @param {object} item objeto com informações do registro atual
		 */
		closeDriverSynchronizationAtak: function() {
			this.show_driver_synchronization_atak = false;
			this.load();
		},
	}
}
</script>

<style scoped>
.add-new {
	float: right;
	margin-top: 10px;
	border: none;
	background: #d9d9d9;
	color: #000;
	font-weight: bold;
	font-size: 12px;
	padding: 10px 15px;
	margin-left: 15px;
}

.inner-wrapper {
	padding: 15px 0;
	background: #fff;
}

.inner-wrapper-right {
	padding: 15px;
	background: #fff;
}

.remove-my-driver {
	background: red;
	color: #fff;
	font-weight: bold;
	font-size: 12px;
	border: none;
	padding: 5px 15px;
}

.my-driver-route {
	background: #222;
	color: #fff;
	font-weight: bold;
	font-size: 12px;
	border: none;
	padding: 5px 15px;
}




.button-create {
	float: right;
	margin-top: 5px;
}

.search {
	background: #fff;
	padding: 15px;
	border-top: 1px solid #f0f0f0;
	border-bottom: 1px solid #f0f0f0;
}

.search > label {
	font-weight: bold;
	font-size: 12px;
}

.search > input {
	width: 140px;
	margin-left: 15px;
}

.btn-delivery {
	float: right;
	margin-top: 10px;
	border: none;
	background: #d9d9d9;
	color: #000;
	font-weight: bold;
	font-size: 12px;
	padding: 10px 15px;
	margin-left: 15px;
}

.add-new:disabled,
.btn-delivery:disabled {
	cursor: not-allowed;
	opacity: .4;
}
</style>